export default __webpack_public_path__ + "static/media/mlogo.e5c24b14.svg";